// extracted by mini-css-extract-plugin
export default {"nodata":"R60uDqy50BTyFlp5CYZg","placeHolderShimmer":"E6pk6JMZJSoZaFnlq77B"};